import React, { useState, useEffect } from 'react';
import './grid.css';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const PatientSupport = () => {
  const [formState, setFormState] = useState({
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    message: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  // If there's formData in location.state, set it on component mount
  useEffect(() => {
    if (location.state?.formData) {
      setFormState(location.state.formData);
    }
  }, [location.state]);

  const formattedDate = formState?.dateOfBirth
    ? new Date(formState.dateOfBirth).toLocaleDateString('en-US')
    : '';

  const handleSubmit = (e) => {
    e.preventDefault();
    let form = e.target;
    let formData = new FormData(form);
    let formDataObj = Object.fromEntries(formData.entries());

    let newErrors = {};
    if (!formDataObj.message) newErrors.message = true;

    // If any errors exist, set errors and don't proceed
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    } else {
      setErrors({});
    }

    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setShowMessage(true); // Show Thank You message
    }, 1000); // Simulated delay
  };

  const handleCancelClick = () => {
    navigate('/'); // Redirect to the access page
  };

  return (
    <div>
      {showMessage ? (
       <div className="col-sm-offset-4 col-sm-4 col-md-4 col-lg-4 mt-5">
         
          <h2>Thank You</h2>
          <p>
            Your message has been successfully submitted. Our support team will
            get back to you soon!
          </p>       
        </div>
      ) : (
        <>
           <div className="col-sm-offset-4 col-sm-4 col-md-4 col-lg-4 mt-5">
           <div className="col-sm-offset-1">
            <h2 className="mb-3">Contact To Support</h2>
            <p>
              Patient data not found! For assistance, please reach out to our
              support team. We're here to help with any questions or issues you
              may have, and we strive to respond as quickly as possible.
              <br />
              <br />
            </p>
          </div>
          </div>
          <div className="col-sm-offset-4 col-sm-4 col-md-4 col-lg-4">
            <form className="form-horizontal loginForm" onSubmit={handleSubmit}>
              <div className="row">
                <div className="form-group shift-left">
                  <label className="col-md-3 p-0 pt-2 col-form-label font-bold text-right">
                    First Name
                  </label>
                  <div className="col-md-8">
                    <input
                      className={`form-control ${formState?.firstName ? 'readonly-disabled' : ''}`}
                      value={formState?.firstName || ''}
                      placeholder="Enter first name"
                      id="first"
                      size="30"
                      type="text"
                      tabIndex="1"
                      name="firstName"
                      readOnly
                    />
                  </div>
                </div>

                <div className="form-group shift-left">
                  <label className="col-md-3 p-0 pt-2 col-form-label font-bold text-right">
                    Last Name
                  </label>
                  <div className="col-md-8">
                    <input
                       className={`form-control ${formState?.lastName ? 'readonly-disabled' : ''}`}
                      value={formState?.lastName || ''}
                      placeholder="Enter last name"
                      id="last"
                      size="30"
                      type="text"
                      tabIndex="2"
                      name="lastName"
                      readOnly
                    />
                  </div>
                </div>

                <div className="form-group shift-left">
                  <label className="col-md-3 p-0 pt-2 col-form-label required_before font-bold text-right">
                    Date of Birth
                  </label>
                  <div className="col-md-8">
                    <input
                      className={`form-control ${formattedDate ? 'readonly-disabled' : ''}`}
                      value={formattedDate || ''}
                      id="birth_date"
                      size="30"
                      type="text"
                      tabIndex="3"
                      name="dateOfBirth"
                      placeholder="Select date"
                      readOnly
                    />
                  </div>
                </div>

                <div className="form-group mt-1 shift-left">
                  <label className="col-md-3 p-0 pt-2 col-form-label required_before font-bold text-right">
                    <span className="red-text">*</span> Message
                  </label>
                  <div className="col-md-8">
                    <textarea
                      id="message"
                      className="form-control"
                      name="message"
                      value={formState?.message || ''}
                      onChange={(e) =>
                        setFormState({ ...formState, message: e.target.value })
                      }
                    />
                    {errors.message && (
                      <span className="text-danger">This field is required</span>
                    )}
                  </div>
                </div>
                <div className="form-group mt-3">
                  <button
                    id="submit-combined"
                    type="submit"
                    className="btn btn-primary col-sm-offset-1"
                    disabled={loading}
                  >
                    {loading ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      'Submit'
                    )}
                  </button>
                  <button
                    type="button"
                    className="btn cancelSupport clearform"
                    onClick={handleCancelClick}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </>
      )}
    </div>
  );
};

export default PatientSupport;
